module.exports = __webpack_public_path__ + "media/A4.873ed2f2.mp3";